module.exports = __webpack_public_path__ + "static/media/portfolio1 (27).ce25e906.jpeg";